import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, UntypedFormGroup, NgModel, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { GlobalService } from 'src/app/_services/global.service';
import { TimesService } from '../_services/times.service';
import { Subject, Subscription, forkJoin, takeUntil } from 'rxjs';
import { Listbox } from 'primeng/listbox';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
import { AmplitudeService } from 'src/app/_services/amplitude.service';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';
import { TimeZoneService } from 'src/app/_services/time-zone.service';
import { log } from 'console';

declare var $: any;
@AutoUnsubscribe
@Component({
  selector: 'app-dismissal-time',
  templateUrl: './dismissal-time.component.html',
  styleUrls: ['./dismissal-time.component.scss']
})
export class DismissalTimeComponent implements OnInit {
  dismissalTimesArray = [];
  loading: boolean = false;
  viewFlag: string = "view";
  toggleShowModal: boolean = false;
  toggleModalViewFlag: string = "save";
  currLang;
  grades: any = [];
  selectedGrades: any = [];
  oldSelectedGrades: any = [];
  singleTime;
  single_time_error;
  addGradeForm: UntypedFormGroup;
  is_group_special_time_enabled = false;
  is_group_start_time_buffer_enabled = false;
  singleBufferTime = 0;
  daysOfWeak = [];
  errorsArray = [];
  mappedErrors = [];
  school_closing_time;
  invalidFormFlag: boolean = false;
  errorsFlag: boolean;
  saveNext: boolean;
  nextEndFlag: string = 'next';
  showAlert: boolean = false;
  removedGrade: string;
  showErrorsModal: boolean;
  deleteDismissalFlag:boolean;
  destroy$ = new Subject<void>();
  cut_off_time;
  school_close_time;
  cut_off_time_raw;
  school_close_time_raw;
  outsideRangeKey: string;
  pendingPickupCount: number = 0;
  pendingEarlyCount: number = 0;
  scheduledEarlyCount: number = 0;
  cancelBreakdown: { count: number, labelKey: string }[] = [];
  pendingNotifyParents: boolean = false;
  pendingIsDelete: boolean = false;

  constructor(
    private translate: TranslateService,
    private globalService: GlobalService,
    private dataService: DataService,
    private groupDismissalTimes: TimesService,
    private errorMsgService: ErrorMsgService,
    private amplitudesService: AmplitudeService,
    private timeZoneService:TimeZoneService 
  ) { }

  ngOnInit(): void {
    // to remove the black screen and the stuck error msg popup if error message was just closed in sibling component
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      //console.log('(c)dismissal-time_(f)getLang_(L)65' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
    });

    this.translate.get('init').pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)dismissal-time_(f)tranlat init_(L)71' , res);
      this.daysFields();
    });
    this.dataService.getAllGrades().pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)dismissal-time_(f)getAllGrades_(L)75' , res);
      this.grades = res.map(element => (
        {
          name: element.name,
          id: element.id,
        }
      ))
    })

    this.getDismissalTimes(false);
  }

  getDismissalTimes(updateAllGrades: boolean) {
    this.loading = true;
    let reqArray = [];
    if (updateAllGrades) {
      reqArray = [
        this.groupDismissalTimes.getgradesGroupedByDismissal(),
        this.groupDismissalTimes.getSchoolTimes(),
        this.dataService.updateGradesCache$()
      ]
    }
    else {
      reqArray = [
        this.groupDismissalTimes.getgradesGroupedByDismissal(),
        this.groupDismissalTimes.getSchoolTimes()
      ]
    }
    forkJoin(reqArray).pipe(takeUntil(this.destroy$)).subscribe((results: any) => {
      // this.dismissalTimesArray = results[0];
      this.dismissalTimesArray = this.getDismissalTimesMappper(results[0]);
      this.setSchoolTimes(results[1]);
      // Cache update is now handled automatically by updateGradesCache$()
      this.viewFlag = 'view'
    }
      , err => {

      }
      , () => {
        this.loading = false;
      })
  }

  addDismissalTimes() {
    this.viewFlag = 'add'
    // this.toggleShowModal = true;
    this.amplitudesService.trackEvent('CTA.AddNew.Dismissal',{})
  }




  // initializeDate(event) {
    
  //   let date = event;
  //   let pm: string;
  //   let am: string;
  //   console.log('date' ,  date);
    
  //   if (date == null || date == undefined) {
  //     return '--:--'
  //   }
  //   else {
  //     switch (this.currLang) {
  //       case 'en':
  //         pm = 'PM'
  //         am = 'AM'
  //         break;
  //       case 'ar':
  //         pm = 'م'
  //         am = 'ص'
  //         break;
  //     }
  //     var hours = date.slice(0, 2);
  //     var minutes = date.slice(3, 5);
  //     var ampm = hours >= 12 ? pm : am;
  //     hours = hours % 12;
  //     hours = hours ? hours : 12; // the hour '0' should be '12'
  //     let tempHours = ('0' + hours).slice(-2)
  //     var strTime = tempHours + ':' + minutes + ' ' + ampm;
  //     return strTime;
  //   }

  // }
  initializeDate(event) {
    let date = event;
    let pm: string;
    let am: string;
  
    if (!date || typeof date !== 'string' || !/\d{2}:\d{2}/.test(date)) {
      return '--:--'; // Return early for null, undefined, or invalid date
    }
  
    switch (this.currLang) {
      case 'en':
        pm = 'PM';
        am = 'AM';
        break;
      case 'ar':
        pm = 'م';
        am = 'ص';
        break;
    }
  
    let hours = parseInt(date.slice(0, 2), 10);
    let minutes = date.slice(3, 5);
    
    if (isNaN(hours) || isNaN(parseInt(minutes, 10))) {
      return '--:--'; // Return for invalid hours or minutes
    }
  
    let ampm = hours >= 12 ? pm : am;
    hours = hours % 12;
    hours = hours ? hours : 12; // The hour '0' should be '12'
    let tempHours = ('0' + hours).slice(-2);
    let strTime = `${tempHours}:${minutes} ${ampm}`;
    
    return strTime;
  }
  

  initializeDay(event) {
    let localizedDay;
    switch (event) {
      case 'Sunday':
        switch (this.currLang) {
          case 'en':
            localizedDay = "Sun"
            break;
          case 'ar':
            localizedDay = 'الأحد'
            break;
        }
        break;
      case 'Monday':
        switch (this.currLang) {
          case 'en':
            localizedDay = "Mon"
            break;
          case 'ar':
            localizedDay = 'الأثنين'
            break;
        }
        break;
      case 'Tuesday':
        switch (this.currLang) {
          case 'en':
            localizedDay = "Tue"
            break;
          case 'ar':
            localizedDay = 'الثلاثاء'
            break;
        }
        break;
      case 'Wednesday':
        switch (this.currLang) {
          case 'en':
            localizedDay = "Wed"
            break;
          case 'ar':
            localizedDay = 'الاربعاء'
            break;
        }
        break;
      case 'Thursday':
        switch (this.currLang) {
          case 'en':
            localizedDay = "Thu"
            break;
          case 'ar':
            localizedDay = 'الخميس'
            break;
        }
        break;
      case 'Friday':
        switch (this.currLang) {
          case 'en':
            localizedDay = "Fri"
            break;
          case 'ar':
            localizedDay = 'الجمعة'
            break;
        }
        break;
      case 'Saturday':
        switch (this.currLang) {
          case 'en':
            localizedDay = "Sat"
            break;
          case 'ar':
            localizedDay = 'السبت'
            break;
        }
        break;
    }
    return localizedDay
  }

  toggleSaveNext(event: boolean) { // this function runs on "save" or "save and next" clicks
    this.saveNext = event; // to know user clicked save or save and next
    this.toggleModalViewFlag = "save"; // to toggle the overlay modal to notify parent and save
    this.toggleShowModal = true; // to show the overlay modal 
    this.deleteDismissalFlag = false;
  }

  openDeleteModal(){
    this.toggleModalViewFlag = "delete"; 
    this.toggleShowModal = true; // to show the overlay modal 
  }

  toggleDeleteFlag(){
    this.deleteDismissalFlag = true;
    this.toggleShowModal = false; // to show the overlay modal 
    this.toggleModalViewFlag = "save"; 
    this.toggleShowModal = true; // to show the overlay modal 
  }


  saveDismissalTimes(notifyParents: boolean , is_delete:boolean, requires_confirmation: boolean = false) { // this function run on save from notify parent modal
    this.loading = true;
    this.toggleShowModal = false; // to hide the overlay modal after api finishes but should be on sucess only
    let dismissalObj: any = {}
    let grade_ids = [];
    let body = [];
    grade_ids = this.selectedGrades.map(grade => grade.id);
    grade_ids.forEach(id => {
      dismissalObj = {};
      dismissalObj.grade_id = id;
      dismissalObj.start_time_schedule = this.initializeStartTimeArray();
      dismissalObj.is_special_time_enabled = this.is_group_special_time_enabled;
      dismissalObj.is_start_time_buffer_enabled = this.is_group_start_time_buffer_enabled;
      dismissalObj.notify_dismissal_changed = notifyParents;
      body.push(dismissalObj)
    })

    if(this.deleteDismissalFlag){
      body.forEach(grade=>{
        grade.start_time_schedule = null;
        // grade.start_time_schedule.forEach(dismissal => {
        //   dismissal.start_time = null;
        //   dismissal.is_closed = false;
        //   dismissal.start_time_buffer = 0;
        // });
      })
    }

    // append original selected grades to first grade object
    body[0].old_selected_grades = this.oldSelectedGrades
    this.groupDismissalTimes.updategradesGroupedByDismissal(body, requires_confirmation).pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)dismissal-time_(f)updategradesGroupedByDismissal_(L)286' , res);
      this.resetAllFields();
      if (!this.saveNext) {
        this.getDismissalTimes(true);
      }
      else {
        this.viewFlag = 'add'
        this.loading = false;
      }
    }, err => {
      if(err.status == 409){
        this.pendingNotifyParents = notifyParents;
        this.pendingIsDelete = is_delete;
        this.pendingPickupCount = err.error?.pending_pickup_requests_count || 0;
        this.pendingEarlyCount = err.error?.pending_early_dismissal_requests_count || 0;
        this.scheduledEarlyCount = err.error?.scheduled_early_dismissal_requests_count || 0;
        this.cancelBreakdown = [
          { count: this.pendingPickupCount, labelKey: 'dismissal-times.modal.confirm.pending-pickup' },
          { count: this.pendingEarlyCount, labelKey: 'dismissal-times.modal.confirm.pending-early' },
          { count: this.scheduledEarlyCount, labelKey: 'dismissal-times.modal.confirm.scheduled-early' },
        ].filter(p => p.count > 0);
        this.toggleModalViewFlag = 'confirm_cancel';
        this.toggleShowModal = true;
      }
      else if(err.status == 422){
        this.errorsArray = err.error.errors;
        this.errorHandling(this.errorsArray)
        this.showErrorsModal = true;
      }
      else {
        this.errorMsgService.setMessage(err?.message);
      }
      this.loading = false;

    }, () => {
    })
  }

  confirmCancelRequests() {
    this.toggleShowModal = false;
    this.saveDismissalTimes(this.pendingNotifyParents, this.pendingIsDelete, true);
  }

  closeModal() {
    this.toggleShowModal = false;
  }

  clearSelection(event) {
    // this.showAlert = true;
    if (event == "all") {
      this.selectedGrades = []
      this.removedGrade = this.currLang == 'en' ? "These Grades" : "هذه الصفوف";
    }
    else {
      this.removedGrade = event.name
      this.selectedGrades = this.selectedGrades.filter(grade => grade.id != event.id);
    }
    this.toggleNextEndBtn();
  }

  onSelectionChange(event) { // fires with every listbox selection change
    this.toggleNextEndBtn();
  }

  toggleNextEndBtn() { // check the grades and selected grades length , if equal then the btn is end else next 
    this.nextEndFlag = this.selectedGrades.length == this.grades.length ? 'end' : 'next';
  }

  // pickupt times 

  daysFields() {
    // the input key for the input id 
    // the overlay key is for the overlay div id , this div is used to toggle a grey background color
    this.daysOfWeak = [
      { name: 'grades-classes.add-grade-modal.sun', value: 'Sunday', time: '', buffer_time: 0, input: 'SundayInput', buffer_input: 'SundayBufferInput', overlay: 'SundayOverlay', is_closed: false, is_error: false },
      { name: 'grades-classes.add-grade-modal.mon', value: 'Monday', time: '', buffer_time: 0, input: 'MondayInput', buffer_input: 'MondayBufferInput', overlay: 'MondayOverlay', is_closed: false, is_error: false },
      { name: 'grades-classes.add-grade-modal.tue', value: 'Tuesday', time: '', buffer_time: 0, input: 'TuesdayInput', buffer_input: 'TuesdayBufferInput', overlay: 'TuesdayOverlay', is_closed: false, is_error: false },
      { name: 'grades-classes.add-grade-modal.wed', value: 'Wednesday', time: '', buffer_time: 0, input: 'WednesdayInput', buffer_input: 'WednesdayBufferInput', overlay: 'WednesdayOverlay', is_closed: false, is_error: false },
      { name: 'grades-classes.add-grade-modal.thu', value: 'Thursday', time: '', buffer_time: 0, input: 'ThursdayInput', buffer_input: 'ThursdayBufferInput', overlay: 'ThursdayOverlay', is_closed: false, is_error: false },
      { name: 'grades-classes.add-grade-modal.fri', value: 'Friday', time: '', buffer_time: 0, input: 'FridayInput', buffer_input: 'FridayBufferInput', overlay: 'FridayOverlay', is_closed: false, is_error: false },
      { name: 'grades-classes.add-grade-modal.sat', value: 'Saturday', time: '', buffer_time: 0, input: 'SaturdayInput', buffer_input: 'SaturdayBufferInput', overlay: 'SaturdayOverlay', is_closed: false, is_error: false }
    ]
  }

  toggleMultibleView(e) {
    // to toggle the view between on time and multiple special times 
    if (e.target.checked) {
      // to reset single time in case checkbox is checked , to enter multiple times only 
      this.singleTime = "";
      this.single_time_error = false;
      this.resetErrorsArray();
      this.is_group_special_time_enabled = true;
    }
    else {
      this.is_group_special_time_enabled = false;
      // to reset multiple times in case checkbox is unchecked , to enter single time only 
      this.resetAllDays();
    }

    this.toggleMatFieldWidth();
    // this.resetBufferTime();
  }

  toggleBufferTime(e) {
    if (e.target.checked) {
      this.is_group_start_time_buffer_enabled = true;
    }
    else {
      this.is_group_start_time_buffer_enabled = false;
      this.resetBufferTime();

    }
    this.toggleMatFieldWidth();
  }

  validateInputNumber(event) {
    const el = event.target
    if (el.type == "number" && el.max && el.min) {
      let value = parseInt(el.value)
      el.value = value // for 000 like input cleanup to 0
      let max = parseInt(el.max)
      let min = parseInt(el.min)
      if (value > max) el.value = el.max
      if (value < min) el.value = el.min
      if (el.value == "" || el.value == null || el.value == undefined) {
        el.value = el.min;
      }
    }
  }


  initializeStartTimeArray() {
    let startTime = []
    if (this.is_group_special_time_enabled) {
      startTime = []
      this.daysOfWeak.forEach(element => {
        startTime.push({
          day_of_week: element.value,
          start_time: this.timeZoneService.convertToSaudiTime(element.time, "HH:mm" , "HH:mm"),
          is_closed: element.is_closed,
          start_time_buffer: element.buffer_time
        })
      });
    }
    else {
      startTime = [];
      startTime.push({
        day_of_week: 'All',
        start_time: this.timeZoneService.convertToSaudiTime(this.singleTime, "HH:mm" , "HH:mm"),
        start_time_buffer: this.singleBufferTime
      })
    }

    return startTime
  }

  toggleDayClosed(e) {
    // toggle disabled class on the field that only change the bg-color to grey
    $(`#${e.value}Overlay`).toggleClass('disabled');
    // toggle attribute readonlyonly on the input to remove the stopwatch icon and disaple the functionality
    $(`#${e.value}Input`).attr('readonly', (_, attr) => !attr);
    // toggle attribute disabled  on the input to remove the time placeholder
    $(`#${e.value}Input`).attr('disabled', (_, attr) => !attr);
    // toggle disabled_buffer class on the buffer time field that only change the bg-color to grey
    $(`#${e.value}BufferInput`).toggleClass('disabled_buffer');
    // reset time buffer field value if day is closed
    if (e.is_closed) {
      $(`#${e.value}BufferInput`).val(0);
    }
    let selectedDay;
    // to find the selected day and reset it's time on toggle
    selectedDay = this.daysOfWeak.find(day => day.value == e.value);
    selectedDay.time = '';
    selectedDay.is_error = false;
    selectedDay.is_closed = !selectedDay.is_closed;
    // this.daysOfWeak.some(day => day.is_error == true)?this.invalidFormFlag = true : this.invalidFormFlag = false
    this.resetErrorsArray();
  }

  toggleMatFieldWidth() {
    const root = document.documentElement;
    if (this.currLang == 'ar' && this.is_group_special_time_enabled && this.is_group_start_time_buffer_enabled) {
      root.style.setProperty('--width', ' 35.6406px');
    }
    else if (this.currLang == 'ar' && this.is_group_special_time_enabled && !this.is_group_start_time_buffer_enabled) {
      root.style.setProperty('--width', ' 248px');
    }

  }

  hasTimeRangeError(): boolean {
    if (this.is_group_special_time_enabled) {
      return this.daysOfWeak.some(day => day.is_error);
    }
    return !!this.single_time_error;
  }

  isOutsideAllowedRange(value: string): boolean {
    // valid time must be within [cut_off_time, school_close_time] inclusive.
    // each bound is enforced independently — if only one is set, still enforce that one.
    if (!value) return false;
    if (this.cut_off_time && value < this.cut_off_time) return true;
    if (this.school_close_time && value > this.school_close_time) return true;
    return false;
  }

  getError(event) {
    this.resetErrorsArray();
    if (event.target.id == "SingleInput") {
      if (this.isOutsideAllowedRange(event.target.value)) {
        // time is outside [cut_off_time, school_close_time]
        this.single_time_error = true;
      }
      else {
        this.single_time_error = false;
      }
    }
    else {
      // find selected day from daysofWeak array
      let selectedDay = this.daysOfWeak.find(day => day.input == event.target.id)
      // check if the entered time falls within the allowed range [cut_off_time, school_close_time]
      if (this.isOutsideAllowedRange(event.target.value)) {
        selectedDay.is_error = true;
      }
      else {
        selectedDay.is_error = false;
      }
      /* check if at least one of the days in the daysOfWeak array
      has a true value of is_error key that means on time is invalid 
      so toggle the form validation flag to true
      */
      this.daysOfWeak.some(day => day.is_error == true) ? this.invalidFormFlag = true : this.invalidFormFlag = false
    }

  }

  resetErrorsArray() {
    this.errorsFlag = false;
    this.errorsArray = [];
  }

  resetAllDays() {
    this.daysOfWeak.forEach(day => {
      day.time = '';
      day.is_closed = false;
      day.is_error = false;
    })
    this.resetErrorsArray();
  }

  resetBufferTime() {
    this.daysOfWeak.forEach(day => {
      day.buffer_time = 0;
    })
    this.singleBufferTime = 0;
  }
  resetStartingTime() {
    // check the value of ending time field , if it's empty reset it again so the field reset in the view  
    if ($("#schoolStart").val() == '') {
      $("#schoolStart").val('')
    }
  }




  editDismissalGroup(dismissal , is_delete:boolean) {
    let selectedDay;
    // to fix the bug Early dismissal adding or delete grade reset the dismissal time for the group in case of (Set Time For Specific Days) button is off
    if(dismissal.is_group_special_time_enabled == false){
    this.singleTime = dismissal?.dismissal_time[0]?.start_time
    }

    this.is_group_special_time_enabled = dismissal?.is_group_special_time_enabled;
    this.is_group_start_time_buffer_enabled = dismissal?.is_group_start_time_buffer_enabled;
    if (dismissal.grades.length > 0) {
      this.selectedGrades = dismissal.grades;
      this.oldSelectedGrades = this.selectedGrades.map(grade => grade.id);      
    }
    if (dismissal.dismissal_time.length > 0) {
      this.daysOfWeak.forEach(day => {
        selectedDay = dismissal.dismissal_time.find(time => time.day_of_week == day.value);
        day.time = selectedDay.start_time;
        day.is_closed = selectedDay.is_closed;
        day.buffer_time = selectedDay.start_time_buffer
      })
    }
    if(is_delete){
    this.openDeleteModal()
    this.amplitudesService.trackEvent('CTA.Delete_Dismissal_Time',{})
    }
    if(!is_delete){
      this.viewFlag = 'edit';
      this.deleteDismissalFlag = false;
      this.amplitudesService.trackEvent('CTA.Edit_Dismissal_Time',{})
    }
  }

  resetAllFields() {
    this.daysFields();
    this.selectedGrades = [];
    this.oldSelectedGrades = [];
    this.singleTime = "";
    this.singleBufferTime = 0;
    this.is_group_special_time_enabled = false;
    this.is_group_start_time_buffer_enabled = false;
    this.showAlert = false;
    this.deleteDismissalFlag = false;
  }

  goBack() {
    this.resetAllFields();
    this.getDismissalTimes(true);
    this.viewFlag = 'view';
  }


  errorHandling(errors) {
    /* this method to map the dissmissal error with keys like this (0.start_time_schedule.0)
    the number at the start of the key represt which grade has the error
    the number at the last of the key represent which day has the error
    the idea is to get the number representing the grade from the string for all the objects hence the regex
    then user his number as an index for the selected grades to get the grade name 
    then merge the errors based on same key which is the grade number
    */ 

    // this regex to get number that has a dot afte it , which is the first number we need
    const regex = /(\d+)\./g;
    let tempArray = []
    this.mappedErrors = [];
    for (var key in errors) {
      let tempObj: any = {}
      // to get the number matching the regex then remove the dot from it then change it's type from string to number
      tempObj.name = Number(key.match(regex)[0].replace('.', ''));
      tempObj.value = errors[key]
      tempArray.push(tempObj)
    }
    // to merge the errors based on key , so that every number "representing a grade" has an array of value contains all the errors
    this.mappedErrors = this.mergeBasedOnKey(tempArray);
  }


  mergeBasedOnKey(list) {
    let c = Object.values(list.reduce((a, b) => {
      a[b.name] = a[b.name] || { name: b.name, value: [] }
      if (typeof (b['value']) == "string") {
        a[b.name].value.push(b['value'])
      }
      else {
        a[b.name].value = [...a[b.name].value, ...b.value]
      }
      return a

    }, {}))
    return c
  }

  ngOnDestroy(): void {
  }

  getDismissalTimesMappper(dismissalTimes:any){
    return dismissalTimes.map((item: any) => ({
      ...item,
      dismissal_time: item.dismissal_time.map((dismissal: any) => ({
        ...dismissal,
        start_time: this.timeZoneService.convertToLocalTime(dismissal.start_time,"HH:mm" , "HH:mm"),
      })),
    }));
  }

  setSchoolTimes(res: any) {
    this.cut_off_time_raw = res?.last_estimated_pickup_time_for_early_dismissal_requests;
    this.school_close_time_raw = res?.school_closing_time;
    this.cut_off_time = this.timeZoneService.convertToLocalTime(this.cut_off_time_raw, "HH:mm:ss", "HH:mm:ss");
    this.school_close_time = this.timeZoneService.convertToLocalTime(this.school_close_time_raw, "HH:mm:ss", "HH:mm:ss");
    this.outsideRangeKey =
      this.cut_off_time_raw && this.school_close_time_raw ? 'dismissal-times.school-times.outside-range-both' :
      this.cut_off_time_raw ? 'dismissal-times.school-times.outside-range-after' :
      'dismissal-times.school-times.outside-range-before';
  }
}
